<h2 class="mb-5">{{'main.cookies.title' | translate}}</h2>

<p>
  {{'main.cookies.body' | translate}}
</p>

<div class="flex items-center justify-between mt-5">
  <button class="btn danger" (click)="dialogRef.close(false)">{{'main.button.refuse' | translate}}</button>
  <button class="btn blue" (click)="dialogRef.close(true)">{{'main.button.accept' | translate}}</button>
</div>
